jQuery(document).ready(function ($) {
    'use strict';

    $('.captcha input').change(function () {
        if ( $(this).val() ) {
            $('.gform_button').prop('disabled', true);
        } else {
            $('.gform_button').prop('disabled', false);
        }
    });

});